<template>
  <div class="flex items-center justify-center flex-col w-full h-full p-10 text-gray-400">
    {{ $t('No results') }}
  </div>
</template>

<script>
export default {
  props: {
  },
}
</script>

<style lang="scss" scoped>
</style>
